import { get } from 'lodash'
import { useEffect, useRef } from 'react'
import { Button, Form } from 'react-bootstrap'
import { FormInput } from '../formControl'
import SearchIcon from '../../assets/images/icons/search-icon.svg';
import './index.scss';

// delay: debounce in ms for onChangeMode; blurOnSearch: drop focus once it fires
// (the workflow board's original behaviour, kept as the default).
const SearchBox = ({
  isLabel = true,
  onChangeMode = false,
  onChange,
  name = 'search',
  delay = 700,
  blurOnSearch = true,
  ...otherProps
}) => {
  // A ref, so a re-render between keystrokes cannot orphan a pending timer.
  const timerRef = useRef(null)
  const formRef = useRef()
  const inputRef = useRef()

  useEffect(() => () => clearTimeout(timerRef.current), [])

  const handleSearch = (e) => {
    e.preventDefault()
    if (!onChangeMode) return
    clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => {
      formRef.current?.click()
      if (blurOnSearch) inputRef.current?.blur()
    }, delay)
  }

  const search = (e) => {
    e.preventDefault()
    clearTimeout(timerRef.current)
    const value = get(e.target.elements, `${name}.value`, '')
    onChange(value)
  }

  return (
    <Form onSubmit={search} className='block-search'>
      <Button type='submit' ref={formRef} className='d-none'/>
      <img className="icon" src={SearchIcon} alt="" />
      <FormInput
        ref={inputRef}
        style={{ minHeight: '45px' }}
        className='border-0 bg-white shadow-sm form-input'
        id='search-box'
        name={name}
        label={isLabel ? () => (
          <small className='text-secondary fs-sub text-uppercase fw-bold'>
            Search
          </small>
        ) : null}
        onChange={handleSearch}
        placeholder='Search...'
        {...otherProps}
      />
    </Form>
    
  )
}

export default SearchBox
